const CanadaCities = {
  Quebec: [
    "Montreal",
    "Quebec City",
    "Laval",
    "Gatineau",
    "Longueuil",
    "Sherbrooke",
    "Saguenay",
    "Levis",
    "Trois-Rivières",
    "Terrebonne",
    "Saint-Jean-sur-Richelieu",
    "Repentigny",
    "Drummondville",
    "Saint-Jérôme",
    "Acton Vale",
    "Alma",
    "Amos",
    "Amqui",
    "Baie-Comeau",
    "Baie-D'Urfé",
    "Baie-Saint-Paul",
    "Beaconsfield",
    "Beauceville",
    "Beauharnois",
    "Beaupré",
    "Bécancour",
    "Bedford",
    "Belleterre",
    "Beloeil",
    "Berthierville",
    "Blainville",
    "Boisbriand",
    "Bois-des-Filion",
    "Bonaventure",
    "Boucherville",
    "Bromont",
    "Brossard",
    "Brownsburg-Chatham",
    "Candiac",
    "Cap-Chat",
    "Cap-Santé",
    "Carignan",
    "Carleton-sur-Mer",
    "Causapscal",
    "Chambly",
    "Chandler",
    "Chapais",
    "Charlemagne",
    "Châteauguay",
    "Château-Richer",
    "Chibougamau",
    "Clermont",
    "Coaticook",
    "Contrecoeur",
    "Cookshire-Eaton",
    "Coteau-du-Lac",
    "Côte-Saint-Luc",
    "Cowansville",
    "Crabtree",
    "Danville",
    "Daveluyville",
    "Dégelis",
    "Delson",
    "Desbiens",
    "Deux-Montagnes",
    "Disraeli",
    "Dolbeau-Mistassini",
    "Dollard-des-Ormeaux",
    "Dorval",
    "East Angus",
    "Farnham",
    "Fermont",
    "Forestville",
    "Gaspé",
    "Granby",
    "Hampstead",
    "Hudson",
    "Huntingdon",
    "Joliette",
    "Kirkland",
    "La Malbaie",
    "La Prairie",
    "L'Ancienne-Lorette",
    "L'Assomption",
    "Lac-Mégantic",
    "Lachute",
    "Lorraine",
    "Louiseville",
    "Magog",
    "Marieville",
    "Mascouche",
    "Matane",
    "Mercier",
    "Mirabel",
    "Mont-Joli",
    "Mont-Laurier",
    "Mont-Royal",
    "Mont-Saint-Hilaire",
    "Montmagny",
    "Notre-Dame-de-l'Île-Perrot",
    "Pincourt",
    "Pointe-Claire",
    "Port-Cartier",
    "Prévost",
    "Rimouski",
    "Rivière-du-Loup",
    "Roberval",
    "Rosemère",
    "Rouyn-Noranda",
    "Saint-Augustin-de-Desmaures",
    "Saint-Basile-le-Grand",
    "Saint-Bruno-de-Montarville",
    "Saint-Constant",
    "Saint-Eustache",
    "Saint-Georges",
    "Saint-Hyacinthe",
    "Saint-Lambert",
    "Saint-Lazare",
    "Saint-Lin–Laurentides",
    "Sainte-Adèle",
    "Sainte-Anne-de-Bellevue",
    "Sainte-Catherine",
    "Sainte-Julie",
    "Sainte-Thérèse",
    "Salaberry-de-Valleyfield",
    "Senneville",
    "Sept-Îles",
    "Shawinigan",
    "Sorel-Tracy",
    "Val-d'Or",
    "Varennes",
    "Vaudreuil-Dorion",
    "Victoriaville",
    "Ville-Marie",
    "Waterloo",
    "Westmount",
  ],
  Ontario: [
    "Toronto",
    "Ottawa",
    "Mississauga",
    "Brampton",
    "Hamilton",
    "London",
    "Markham",
    "Vaughan",
    "Kitchener",
    "Ajax",
    "Aurora",
    "Barrie",
    "Burlington",
    "Cambridge",
    "Chatham-Kent",
    "Guelph",
    "Kingston",
    "Niagara Falls",
    "Oakville",
    "Oshawa",
    "Peterborough",
    "Sarnia",
    "St. Catharines",
    "Thunder Bay",
    "Waterloo",
    "Welland",
    "Whitby",
    "Windsor",
    "Wasaga Beach",
    "Belleville",
    "Brant",
    "Brantford",
    "Brockville",
    "Caledon",
    "Clarence-Rockland",
    "Clarington",
    "Collingwood",
    "Cornwall",
    "Dryden",
    "Elliot Lake",
    "Fort Erie",
    "Greater Sudbury",
    "Haldimand County",
    "Halton Hills",
    "Kawartha Lakes",
    "Kenora",
    "Kingsville",
    "Lakeshore",
    "Leamington",
    "Midland",
    "Milton",
    "Norfolk County",
    "North Bay",
    "Orangeville",
    "Orillia",
    "Owen Sound",
    "Pembroke",
    "Pickering",
    "Port Colborne",
    "Prince Edward County",
    "Quinte West",
    "Richmond Hill",
    "Sault Ste. Marie",
    "St. Thomas",
    "Stratford",
    "Temiskaming Shores",
    "Thorold",
    "Timmins",
    "Woodstock",
  ],
};

export default CanadaCities;
